import Analytics from '@withlocals/withlocals-analytics';
import { Translator } from 'Translator';
import ChevronIcon from 'components/icons/ChevronIcon';
import React, { useState } from 'react';

import { WlWindow } from '../../../typings/globals/cordova';
import USPModal from './USPModal';

declare const window: WlWindow;

const CSS = require('./USPBanner.less');

function USPBanner() {
  const [show, onShow] = useState(false);
  const onClose = () => onShow(false);
  const onShowModal = () => {
    onShow(true);
    Analytics.track(window.currentPageCategory, 'Covid banner', 'Learn more');
  };

  return (
    <>
      <div className={CSS.Banner} onClick={onShowModal}>
        <div>
          <h3 className={CSS.Title}>
            Explore <span className={CSS.Highlighted}>Comfortably</span>
          </h3>
          <p className={CSS.Text}>
            {Translator.i18n(
              'SearchPage.SmallUSPBanner.text',
              'The safest city tours with local experts',
            )}
          </p>
        </div>
        <div className={CSS.ButtonContainer}>
          <button className={CSS.Button} onClick={onShowModal}>
            {Translator.i18n(
              'SearchPage.SmallUSPBanner.learnMore',
              'Learn more',
            )}{' '}
            <ChevronIcon fill="#FFF" className={CSS.Icon} />
          </button>
        </div>
      </div>
      <USPModal show={show} onClose={onClose} />
    </>
  );
}

export default USPBanner;
